// src/features/users/components/UserInfoCard.tsx
import { Card, formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import type { User } from '../types/user.types';
import { UserStatusBadge } from './UserStatusBadge';

export interface UserInfoCardProps {
  user: User;
}

/**
 * Workspace card: core account info — name, email, phone, status,
 * created date. Pulls straight off the base User record (same shape
 * the list table already uses) — no additional mock data needed for
 * this one. Same field-list markup as
 * customers/components/CustomerInfoCard.tsx and
 * tenants/components/TenantInfoCard.tsx.
 */
export function UserInfoCard({ user }: UserInfoCardProps) {
  return (
    <Card className="vania-user-workspace-card">
      <h2 className="vania-user-workspace-card-title">اطلاعات کاربر</h2>

      <dl className="vania-user-profile-field-grid">
        <div>
          <dt>نام</dt>
          <dd>{user.name}</dd>
        </div>
        <div>
          <dt>نام کاربری</dt>
          <dd dir="ltr">{user.username}</dd>
        </div>
        <div>
          <dt>شناسه تلگرام</dt>
          <dd dir="ltr">{formatPersianNumber(user.telegramId)}</dd>
        </div>
        <div>
          <dt>تلفن</dt>
          <dd dir="ltr">{formatPersianNumber(user.phone)}</dd>
        </div>
        <div>
          <dt>وضعیت حساب</dt>
          <dd>
            <UserStatusBadge status={user.status} />
          </dd>
        </div>
        <div>
          <dt>تاریخ ثبت‌نام</dt>
          <dd dir="ltr">{formatSolarDate(user.createdAt)}</dd>
        </div>
      </dl>
    </Card>
  );
}
